// extracted by mini-css-extract-plugin
export default {"container":"ShippingDetails_container__JTb64","title":"ShippingDetails_title__UvfBY","fullRow":"ShippingDetails_fullRow__NKCfY","sharedRow":"ShippingDetails_sharedRow__fDuQL"};